var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.188,
    height: 20.983,
    viewBox: "0 0 22.188 20.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14885",
    "data-name": "Path 14885",
    d: "M753.945-439.408c.077-.351.134-.709.236-1.052a5.037,5.037,0,0,1,1.312-2.136q4.239-4.236,8.476-8.474a6.858,6.858,0,0,1,3.719-1.995,6.9,6.9,0,0,1,6.612,2.209,6.808,6.808,0,0,1,1.789,5.531,6.976,6.976,0,0,1-2.106,4.308q-4.215,4.214-8.425,8.434a1.034,1.034,0,0,1-1.721-.192.964.964,0,0,1,.116-1.058,2.7,2.7,0,0,1,.235-.255q4.168-4.169,8.338-8.337a5.021,5.021,0,0,0,1.464-2.6,4.922,4.922,0,0,0-1.471-4.762,4.872,4.872,0,0,0-3.969-1.359,4.943,4.943,0,0,0-3.121,1.488q-4.27,4.266-8.534,8.538a2.91,2.91,0,0,0-.778,3.068,2.883,2.883,0,0,0,2.325,2.087,2.928,2.928,0,0,0,2.564-.686c.083-.07.16-.146.237-.222q3.854-3.854,7.71-7.708a1.049,1.049,0,0,0,.344-1.092,1,1,0,0,0-1.57-.527,2.3,2.3,0,0,0-.241.218q-2.476,2.474-4.951,4.949a1.019,1.019,0,0,1-1.437.139,1.007,1.007,0,0,1-.165-1.381,1.859,1.859,0,0,1,.173-.194q2.505-2.506,5.012-5.011a3.039,3.039,0,0,1,3.81-.5,3.04,3.04,0,0,1,.668,4.606c-.073.08-.147.159-.224.236q-3.839,3.839-7.677,7.679a5.2,5.2,0,0,1-2.69,1.479,5.065,5.065,0,0,1-6.013-4.3c-.009-.071-.03-.14-.045-.211Z",
    transform: "translate(-753.945 453.195)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.5643fc81cff10717eddda228af4cb9a6.svg";
export { ForwardRef as ReactComponent };